module.exports = __webpack_public_path__ + "static/chip-6a435e8d9d1e127017baa87e19eb7f62.png";